document.addEventListener("DOMContentLoaded", function() {

    // přepnutí okna tlačítkem
    //========================
    (function () {
        let button = document.querySelector('.JS-readmore-projekty');
        if(typeof(button) === 'undefined' || button === null) return;

        button.addEventListener("click", function () {
            let popisTab = document.querySelector('.projektyTabs a[href="#popis-tab"]');
            if(typeof(popisTab) !== 'undefined' && popisTab !== null)
                popisTab.dispatchEvent(new Event('click'));
        });
    })();


});